import { ChevronRight } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React from "react";

import { darkGreyColor100, primaryColor } from "theme";

const ProductSearchBox = ({
  data,
  setProductSelected,
  setApplicationProgress,
  setScreen
}) => {
  
  return (
    <Box className="mt-6">
      <Typography
        sx={{
          color: darkGreyColor100,
          fontSize: "13px"
        }}
      >
        Search Results:
      </Typography>
      <Box className="mt-2 border max-h-[400px] overflow-y-scroll rounded-[4px] border-[#EFF2F6]">
        {data?.map((item, index) => (
          <Box
            key={index}
            className="flex hover:bg-[#F9FAFB] hover:rounded-[4px] justify-between p-4 border-b border-b-[#EFF2F6] "
            onClick={() => {
              setApplicationProgress("2");
              setProductSelected(item);
              setScreen("SelectCarrier");
            }}
          >
            <Typography
              sx={{
                color: primaryColor,
                fontSize: "14px",
                fontWeight: 600
              }}
            >
              {item?.code}:{" "}
              <span className="text-[#39404B] font-normal">
                {item?.naicsDescription}
              </span>
            </Typography>
            <ChevronRight sx={{ color: primaryColor }} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ProductSearchBox;
